import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=2e89a67d&scoped=true&lang=pug"
import script from "./FormFile.vue?vue&type=script&lang=ts"
export * from "./FormFile.vue?vue&type=script&lang=ts"
import style0 from "./FormFile.vue?vue&type=style&index=0&id=2e89a67d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e89a67d",
  null
  
)

export default component.exports